import { CommonModule } from "@angular/common";
import { Component, OnDestroy, inject, input, output } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { UserService } from "@providers/UserService";
import { Utils } from "@sports-utils/Utils";
import { Subject, takeUntil } from "rxjs";

@Component({
  standalone: true,
  selector: "free-bets-verification",
  templateUrl: "free-bets-verification-component.html",
  styleUrls: ["free-bets-verification-component.scss"],
  imports: [IonicModule, CommonModule, TranslateModule, ReactiveFormsModule, FormsModule],
})
export class FreeBetsVerification implements OnDestroy {
  freeBetSMSVerification = input.required<boolean>();
  freeBetAccountVerification = input.required<boolean>();
  phoneNumber = input.required<string>();
  isMobile = input.required<string>();

  update = output();

  private readonly unsubscribe$ = new Subject();
  form: FormGroup;
  modelForm: { smsCode: string } = { smsCode: "" };
  errorSmsCode = "";

  translate = inject(TranslateService);
  fb = inject(FormBuilder);
  utils = inject(Utils);
  userService = inject(UserService);
  router = inject(Router);

  constructor() {
    this.form = this.fb.group({
      smsCode: [""],
    });
  }

  checkFBCode() {
    const codFB = this.modelForm.smsCode;
    if (codFB === "") {
      this.utils.showError(this.translate.instant("v2_campo_incorrecto"));
    } else {
      this.userService
        .checkPhoneFreeBets(codFB)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (data) => {
            if (data.success) {
              this.errorSmsCode = "";
              this.utils.alert(false, "", this.translate.instant("correctcode"), "OK");
              this.update.emit();
            } else {
              this.utils.showError(this.translate.instant("incorrectcode"));
              this.update.emit();
            }
          },
          () => {
            this.utils.showError(this.translate.instant("m_menu_serverFail"));
          },
        );
    }
  }

  reSendFBCode() {
    this.userService
      .resendFBCode()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (data) => {
          if (data.success) {
            this.utils.alert(false, "", this.translate.instant("regsmsrecib"), "OK");
          } else {
            this.utils.alert(false, "", this.translate.instant("regsmsmore"), "OK");
          }
        },
        () => {
          this.utils.showError(this.translate.instant("m_menu_serverFail"));
        },
      );
  }

  goToVer() {
    this.router.navigate(["DocumentVerificationPage", {}]);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
